<template>
  <div>
    <div class='title'>
      <span> Life Remaker - 重开模拟器</span>
    </div>

    <div class='map'>
      <world-map></world-map>
    </div>

    <div class='buttonGroup'>
      <el-button @click="clickRemake" :disabled="buttonCooldown" type='primary'>
        {{buttonGroup_currentLang[0]}}
      </el-button>

      <el-button @click='clickReset' :disabled="(rawList.length==0?true:false)||buttonCooldown" type='warning'>
        {{buttonGroup_currentLang[1]}}
      </el-button>
    </div>

    <div class='tableGroup'>
      <el-table :data="summary" style="width:100%">
        <el-table-column :label="summaryTable_currentLang[0]" prop="amount"></el-table-column>
        <el-table-column :label="summaryTable_currentLang[1]" prop="most"></el-table-column>
        <el-table-column :label="summaryTable_currentLang[2]" prop="best"></el-table-column>
        <el-table-column :label="summaryTable_currentLang[3]" prop="average"></el-table-column>
      </el-table>

      <el-table :data="list" style="width:100%" max-height="300" border :empty-text="tableTips_currentLang[0]">
        <el-table-column :label="listTable_currentLang[0]" prop="number" width="50"></el-table-column>
        <el-table-column :label="listTable_currentLang[1]" prop="continent" width="100"></el-table-column>
        <el-table-column :label="listTable_currentLang[2]" prop="country"></el-table-column>
        <el-table-column :label="listTable_currentLang[3]" prop="gender" width="80%"></el-table-column>
        <el-table-column :label="listTable_currentLang[4]" prop="rank"></el-table-column>
        <el-table-column :label="listTable_currentLang[5]" prop="chance"></el-table-column>
      </el-table>

      <div class='tableTip'>
        <i class='el-icon-caret-left'></i>
        <span>{{tableTips_currentLang[1]}}</span>
        <i class='el-icon-caret-right'></i>
      </div>
    </div>

    <div class='tipGroup'>
      <div v-for='(item,index) in tipText_currentLang' v-bind:key='index'>
        <p class='tipItem'>{{index+1}}. {{item}}</p>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import * as server from '../../../server.js'
import WorldMap from './WorldMap.vue'

export default {
  name: 'mini-liferemaker',
  components: {
    WorldMap
  },
  data () {
    return {
      rawList: [],
      list: [],
      summary: [{
        amount: 0,
        most: "",
        best: "",
        average: ""
      }],
      listByCountry: [],
      mostByAmount: {
        country: "",
        amount: 0
      },
      mostByHDI: {
        country: "",
        hdi: 0
      },
      lang: 'cn',
      langData_buttonGroup_cn: ['重开', '清空列表'],
      langData_buttonGroup_en: ['Remake (Reborn)', 'Reset List'],
      langData_summaryTable_cn: ['总次数', '次数最多', '评分最高', '平均评分'],
      langData_summaryTable_en: ['Total', 'Most', 'Best', 'Average'],
      langData_listTable_cn: ['次数', '大洲', '国家', '性别', '评级', '概率'],
      langData_listTable_en: ['No.', 'Contient', 'Country', 'Gender', 'Star', 'Chance'],
      langData_tableTips_cn: ['暂无数据', '左右滑动'],
      langData_tableTips_en: ['No Data', 'Slide'],
      langData_gender_cn: ['男', '女'],
      langData_gender_en: ['Male', 'Female'],
      langData_contient_cn: ['亚洲', '非洲', '北美洲', '南美洲', '欧洲', '大洋洲'],
      langData_contient_en: ['Asia', 'Africa', 'North Amercia', 'South Amercia', 'Europea', 'Oceania'],
      summaryTable_currentLang: ['总次数', '次数最多', '评分最高', '平均评分'],
      listTable_currentLang: ['次数', '大洲', '国家', '性别', '评级', '概率'],
      buttonGroup_currentLang: ['重开', '清空列表'],
      tableTips_currentLang: ['暂无数据', '左右滑动'],
      innerData_hdi: [0.1, 0.5, 0.6, 0.65, 0.7, 0.78, 0.85, 0.9, 0.95],
      buttonCooldown: false,
      langData_tipText_cn: ['本内容仅供娱乐, 不代表本人观点。', '应用中所有"国家"字样代表"国家"、"地区"（包括受争议地区、特区、殖民地）等。', '评分数据参考人类发展指数（HDI），数据来源:https://en.wikipedia.org/wiki/Human_Development_Index', '部分特殊国家、地区可能有地图、评分缺失，属正常现象'],
      langData_tipText_en: ['This is for entertainment only and does not stand for any personal opinion.', 'Country stands for Country, Region (Disputed region, special region, colony), etc.', 'Ranking data refers to the HDI, from https://en.wikipedia.org/wiki/Human_Development_Index', 'There might be a lack of map and ranking data for few special countries and regions which is normal.'],
      tipText_currentLang: ['本内容仅供娱乐, 不代表本人观点。', '应用中所有"国家"字样代表"国家"、"地区"（包括受争议地区、特区、殖民地）等。', '评分数据参考人类发展指数（HDI），数据来源:https://en.wikipedia.org/wiki/Human_Development_Index', '部分特殊国家、地区可能有地图、评分缺失，属正常现象'],
    }
  },
  methods: {
    clickRemake () {
      axios({
        method: 'post',
        url: server.default.liferemaker,
        data: new URLSearchParams({
          'liferemaker': this.rawList.length
        })
      }).then((response) => {
        if (response.status != 200) {
          this.$alert('无法连接到服务器, 请稍后重试', '消息');
        }
        else {
          this.rawList.unshift({
            number: this.rawList.length + 1,
            continent: response.data.continent,
            country: response.data.cn,
            gender: Math.round(Math.random()),
            rank: response.data.hdi,
            chance: response.data.chance,
            rawCountry: response.data.country
          });
          if (this.lang == 'en') {
            this.rawList[0].country = response.data.country;
          }
          this.updateList();
          this.updateSummary();
          this.saveToLocal();
        }
      })
      this.buttonCooldown = true;
      setTimeout(() => {
        this.buttonCooldown = false;
      }, 500)
    },
    clickReset () {
      this.rawList = [];
      this.list = [];
      this.summary = [{
        amount: 0,
        most: "",
        best: "",
        average: ""
      }];
      this.listByCountry = [];
      this.mostByAmount = {
        country: "",
        amount: 0
      };
      this.mostByHDI = {
        country: "",
        hdi: 0
      };
      this.buttonCooldown = true;
      this.$bus.$emit('setMapTarget', '', 0);
      localStorage.clear();
      setTimeout(() => {
        this.buttonCooldown = false;
      }, 500)
    },
    updateList () {
      this.list.unshift({
        number: this.list.length + 1,
        continent: this.langData_contient_cn[this.langData_contient_en.indexOf(this.rawList[0].continent)],
        country: this.rawList[0].country,
        gender: this.rawList[0].gender == 1 ? "男" : "女",
        rank: '',
        chance: this.rawList[0].chance / 2 + '%',
      })
      if (this.lang == 'en') {
        this.list[0].continent = this.rawList[0].continent;
        this.list[0].gender = this.rawList[0].gender == 1 ? "M" : "F";
      }
      if (this.rawList[0].rank < 0.1) {
        this.list[0].rank = '该地区无数据'
      }
      else {
        // this.list[0].rank = 0;
        for (let i = 0; i < this.innerData_hdi.length; i++) {
          if (this.innerData_hdi[i] <= this.rawList[0].rank) {
            this.list[0].rank += "★"
            // this.list[0].rank++;
          }
          else break;
        }
        this.$bus.$emit('setMapTarget', [this.rawList[0].rawCountry, this.list[0].rank.length]);
        if (this.rawList[0].rank <= this.innerData_hdi[4] && this.rawList[0].gender == 0) {
          this.list[0].rank = this.list[0].rank.substring(0, this.list[0].rank.length - 1);
          this.list[0].rank += "☆";
          // this.list[0].rank -= 0.5;
        }
        else if (this.rawList[0].gender == 0) {
          this.list[0].rank += "☆";
        }
        // this.list[0].rank += "★";
      }
    },
    updateSummary () {
      this.summary[0].amount = this.list.length;

      for (let i = 0; i <= this.listByCountry.length; i++) {
        if (i == this.listByCountry.length) {
          this.listByCountry.push({
            country: this.list[0].country,
            hdi: this.rawList[0].rank,
            amount: 1
          })
          break;
        }
        else {
          if (this.listByCountry[i].country == this.list[0].country) {
            this.listByCountry[i].amount++;
            break;
          }
        }
      }

      for (let i = 0; i < this.listByCountry.length; i++) {
        if (this.listByCountry[i].amount >= this.mostByAmount.amount) {
          this.mostByAmount.country = this.listByCountry[i].country;
          this.mostByAmount.amount = this.listByCountry[i].amount;
          this.summary[0].most = this.mostByAmount.country + ' (' + this.mostByAmount.amount + ')';
        }
        if (this.listByCountry[i].hdi >= this.mostByHDI.hdi) {
          this.mostByHDI.country = this.listByCountry[i].country;
          this.mostByHDI.hdi = this.listByCountry[i].hdi;
          this.summary[0].best = this.mostByHDI.country + ' (' + this.mostByHDI.hdi + ')';
        }
      }

      this.summary[0].average = "";
      let totalRank = 0;
      for (let i = 0; i < this.summary[0].amount; i++) {
        totalRank += this.rawList[i].rank;
      }
      let averageHDI = totalRank / this.summary[0].amount;
      this.summary[0].average = (averageHDI * 100).toFixed(3) + "/ 100";
    },
    saveToLocal () {
      localStorage.setItem('rawList', JSON.stringify(this.rawList));
      localStorage.setItem('list', JSON.stringify(this.list));
      localStorage.setItem('summary', JSON.stringify(this.summary));
      localStorage.setItem('listByCountry', JSON.stringify(this.listByCountry));
      localStorage.setItem('mostByAmount', JSON.stringify(this.mostByAmount));
      localStorage.setItem('mostByHDI', JSON.stringify(this.mostByHDI));
    },
    getFromLocal () {
      if (localStorage.length == 6) {
        this.rawList = JSON.parse(localStorage.getItem('rawList'));
        this.list = JSON.parse(localStorage.getItem('list'));
        this.summary = JSON.parse(localStorage.getItem('summary'));
        this.listByCountry = JSON.parse(localStorage.getItem('listByCountry'));
        this.mostByAmount = JSON.parse(localStorage.getItem('mostByAmount'));
        this.mostByHDI = JSON.parse(localStorage.getItem('mostByHDI'));
      }
      else {
        this.clickReset();
      }
    },
    setLang (lang) {
      this.clickReset();
      if (lang == 'lang_cn') {
        this.lang = 'cn';
        this.summaryTable_currentLang = this.langData_summaryTable_cn;
        this.listTable_currentLang = this.langData_listTable_cn;
        this.buttonGroup_currentLang = this.langData_buttonGroup_cn;
        this.tipText_currentLang = this.langData_tipText_cn;
        this.tableTips_currentLang = this.langData_tableTips_cn;
      }
      else if (lang == 'lang_en') {
        this.lang = 'en';
        this.summaryTable_currentLang = this.langData_summaryTable_en;
        this.listTable_currentLang = this.langData_listTable_en;
        this.buttonGroup_currentLang = this.langData_buttonGroup_en;
        this.tipText_currentLang = this.langData_tipText_en;
        this.tableTips_currentLang = this.langData_tableTips_en;
      }
    }
  },
  mounted () {
    this.$bus.$on('setLang', this.setLang);
    this.getFromLocal();
  },
  beforeDestroy () {
    this.$bus.$off('setLang');
  },
}
</script>

<style scoped>
.title {
  text-align: center;
  font-size: 150%;
  margin: 20px 0 20px 0;
}
.buttonGroup {
  margin: 25px 0 15px 0;
  text-align: center;
}
.buttonGroup .el-button {
  margin: 0 15px 0 15px;
}
.tableGroup .el-table {
  margin: 30px 0 0 0;
}
.tableGroup .tableTip {
  text-align: center;
  margin: 0 0 30px 0;
}
.tipGroup .tipItem {
  margin: 5px 0 5px 20px;
}
</style>